import React from "react";

/**
 * Brand mark for the Metadata Import interface — a small glyph (rows of metadata flowing down into
 * a collection tray) that sits in front of the wordmark in `MetadataImportHeader`, mirroring the
 * role `SpotterMark` (a reticle) plays for Spotter. Deliberately generic — no NFL/Spotter imagery.
 * Uses `currentColor` so the header controls the tone (the `--miAccent` blue).
 */
const MetadataImportMark = ({ size = 26 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    aria-hidden="true"
    role="img"
  >
    <rect
      x="1.25"
      y="1.25"
      width="25.5"
      height="25.5"
      rx="7"
      stroke="currentColor"
      strokeOpacity="0.5"
      strokeWidth="1.5"
    />
    {/* source rows */}
    <rect x="7" y="6.5" width="14" height="2.1" rx="1.05" fill="currentColor" />
    <rect
      x="7"
      y="10.4"
      width="10"
      height="2.1"
      rx="1.05"
      fill="currentColor"
      fillOpacity="0.6"
    />
    {/* flow arrow into the tray */}
    <path
      d="M14 13.4v4.2m0 0 2.4-2.4M14 17.6l-2.4-2.4"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* collection tray */}
    <path
      d="M6.6 19.4v1.2a1.6 1.6 0 0 0 1.6 1.6h11.6a1.6 1.6 0 0 0 1.6-1.6v-1.2"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

export default MetadataImportMark;
